var map = {
	"./h5p": [
		"b1ad",
		"chunk-44b45a65"
	],
	"./h5p.vue": [
		"b1ad",
		"chunk-44b45a65"
	],
	"./image": [
		"cd07",
		"chunk-c63e3648"
	],
	"./image.vue": [
		"cd07",
		"chunk-c63e3648"
	],
	"./mauthor": [
		"6bb6",
		"chunk-f6804eb4"
	],
	"./mauthor.vue": [
		"6bb6",
		"chunk-f6804eb4"
	],
	"./text": [
		"ab94",
		"chunk-cc5529d8"
	],
	"./text.vue": [
		"ab94",
		"chunk-cc5529d8"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "2835";
module.exports = webpackAsyncContext;